<template>
   
    <div ref="complement" class="Credits">

        <div class="Credits__container">

            <div class="Credits__title">{{ trans('PAGES.CREDITS.title') }}</div>
            <div class="Credits__desc"> 
                
                <div class="Credits__groupe" v-html="trans('momenta')"/>

                <div class="Credits__sub">
                    <div class="Credits__title-sub" v-html="trans('directice')"/>
                    <p>Audrey Genois</p>
                </div>

                <div class="Credits__sub">
                    <div class="Credits__title-sub" v-html="trans('team')"/>
                    <p>Stefanie Hessler</p><p>{{ trans('with') }}</p><p>Camille Georgeson-Usher</p><p>Maude Johnson</p><p>Himali Singh Soin</p>
                </div>

                <div class="Credits__sub">
                    <div class="Credits__title-sub" v-html="trans('coordo')"/>
                    <p>Julia Roberge Van Der Donckt</p><p>Lisa Tronca</p>
                </div>

                <div class="Credits__sub">
                    <div class="Credits__title-sub" v-html="trans('rev')"/>
                    <p>Anne-Marie Dubois</p><p>Maude Johnson</p><p>Caitlin Stall-Paquet</p>
                </div>

                <div class="Credits__groupe" v-html="trans('dpt')"/>

                <div class="Credits__sub">
                    <div class="Credits__title-sub" v-html="trans('crea')"/>
                    <p>Nicolas S. Roy</p>
                </div>

                <div class="Credits__sub">
                    <div class="Credits__title-sub" v-html="trans('rea')"/>
                    <p>Raed Moussa</p>
                </div>

                <div class="Credits__sub">
                    <div class="Credits__title-sub" v-html="trans('prod')"/>
                    <p>Raphaëlle Sleurs</p>
                </div>

                <div class="Credits__sub">
                    <div class="Credits__title-sub" v-html="trans('dev')"/>
                    <p>Arnaud Blaszkowski</p>
                </div>

                <div class="Credits__sub">
                    <div class="Credits__title-sub" v-html="trans('ar')"/>
                    <p>Josni Bélanger</p>
                </div>

                <div class="Credits__sub">
                    <div class="Credits__groupe" v-html="trans('finance')"/>
                    <img :src="require('@/commons/img/logos/calq.png')">
                    <img :src="require('@/commons/img/logos/cca_'+ this.lang +'.png')" class="cca">
                    <img :src="require('@/commons/img/logos/mtl.jpg')" class="small">
                    <img :src="require('@/commons/img/logos/rbc.png')">

                </div>

                <div class="Credits__sub">
                    <div class="Credits__groupe" v-html="trans('collabo')"/>
                    <img :src="require('@/commons/img/logos/bixi.png')">
                </div>

            </div>

        </div>  


        <div class="Credits__header">
            <div ref="back" class="Complements__back white" @click="callBack()">
                <img :src="require('@/commons/img/back.png')">
            </div>

        </div>


    </div>
</template>

<script>

import gsap from "gsap"

export default {
    name: 'Credits',
    data: ()=>({
    }),
    translations: {
        en: { 
            credits: 'credits',
            momenta: 'MOMENTA</br>Biennale de l’image',
            directice: 'Executive Director',
            team: 'Curatorial Team 2021',
            coordo: 'Digital Projects Coordinators',
            dpt: 'Dpt.</br>Creative Innovation Studio',
            crea: 'Creative Director',
            rea: 'UX/Art Director ',
            prod: 'Producer',
            dev: 'Web Developer',
            ar: 'Augmented Reality Expert',
            rev: 'Copyediting',
            finance: 'Financial Support', 
            collabo: 'Special Contributor',
            with: 'in collaboration with'
        },
        fr: { 
            credits: 'crédits',
            momenta: 'MOMENTA</br>Biennale de l’image',
            directice: 'Directrice générale',
            team: 'Équipe commissariale 2021',
            coordo: 'Coordonnatrices des projets numériques',
            dpt:'Dpt.</br>Studio d’innovation créative',
            crea: 'Directeur de création',
            rea: 'Réalisateur d’expérience / directeur artistique ',
            prod: 'Productrice',
            dev: 'Développeur web',
            ar: 'Expert en réalité augmentée',
            rev: 'Révision',
            finance: 'Appuis financiers', 
            collabo: 'Collaborateur spécial',
            with: 'avec la collaboration de'
        }
    },


    beforeDestroy() {
        console.log('beforeDestroy');
    },

    mounted() {
        gsap.from(this.$refs.back, { duration: .35, x: 30, delay: .2, alpha: 0 })
    },

    methods: { 
        callBack() {
            gsap.delayedCall(.15, ()=>{ this.$parent.step = 'left' })
        },
    }
}
</script>

<style lang="stylus">

@import '~@/config/Settings'
@import '~@/commons/stylus/Media-queries'

.Credits 

    display flex
    position absolute 
    width 100vw
    top 0

    &__header
        position fixed
        width 100%
   
    &__container
        display flex
        align-items flex-center
        justify-content center
        flex-direction column
        padding 36px 30px 208px
        width 100%

    &__title 
        font-weight 800
        font-size 22px
        text-align center
        line-height 24px
        text-transform uppercase
        padding-bottom 48px

        &-sub 
            font-weight 700

    &__groupe
        font-weight 700
        padding 8px 0 32px
        font-size 18px
        line-height 20px

    &__desc 
        display flex
        align-items flex-center
        justify-content center
        flex-direction column
        text-align center

    &__sub
        padding-bottom 32px
        font-size 16px
        display flex
        flex-direction column
        align-items center

        & img 
            padding 24px 0
            width 40%

            &.small
                width 40%

            &.cca 
                width 55%
                
    & p 
        margin 0px


         
</style>














